/* eslint-disable */
  // var View = com.vizengine.view.View;
  // var ImageView = com.vizengine.view.ImageView;
  // var TextView = com.vizengine.view.TextView;

  export const markerFactories = {
    //marker父容器
    baseWraper: function () {
      let dom = document.createElement("div"); // 可以为任意dom元素
      dom.setAttribute("id", "marker");
      dom.style.position = "relative";
    },
    markerWraper: function (marker) {
      var cell = this.View().parse({
        width: "wrap",
        height: "wrap",
        anchorX: "0.5",
        anchorY: "0.5",
        alpha: "0",
        visibility: 'visible',
        panoPitch: marker.pitch,
        panoHeading: marker.heading
      });
      cell._nativeView.div.setAttribute("class", "abcde")
      return cell;
    },
    //跳转类marker
    panoMarker: function (marker) {
      // 处理展会模板下跳转marker样式
      marker.nameBak = marker.name
      if (marker.templeteType === 'expopc' || marker.templeteType === 'expo') {
        marker.name = ''
      }
      let dom = document.createElement("div"); // 可以为任意dom元素
      dom.style.overflow = "auto";
      dom.markerType = 1;
      dom.vrText = marker.nameBak;
      let domInner = ''
      if (marker && marker.style && marker.style.indexOf('custom') > -1) {
        marker.style = 'custom'
      }
      // console.log(marker)
      switch (marker.style) {
        case "right":
          domInner = `<div style="cursor: pointer; height: 30px; display: flex; align-items: center;">
                        <div id="name" class="text-shadow" style="height: 16px; color: rgb(255, 255, 255); font-size: 12px; line-height: 16px; font-weight: normal; letter-spacing: 0px; word-break: normal">
                          ${marker.name}
                        </div>
                        <div id="icon" class="movingArrowRight" style="width: 40px;height: 30px; margin-top: -6px;"></div>
                      </div>`
          break;
        case "left":
          domInner = `<div style="cursor: pointer; height: 30px; display: flex; align-items: center;">
                        <div id="icon" class="movingArrowLeft" style="width: 40px;height: 30px; margin-top: -6px;"></div>
                        <div id="name" class="text-shadow" style="height: 16px; color: rgb(255, 255, 255); font-size: 12px; line-height: 16px; font-weight: normal; letter-spacing: 0px; word-break: normal">
                          ${marker.name}
                        </div>
                      </div>`
          break;
        case "top":
          domInner = `<div style="cursor: pointer;">
                        <div id="icon" class="movingArrowDown" style="width: 35px; height: 36px; margin: auto;"></div>
                        <div id="name" class="text-shadow" style="height: 16px; color: rgb(255, 255, 255); font-size: 12px; line-height: 16px; font-weight: normal; letter-spacing: 0px; word-break: normal">
                          ${marker.name}
                        </div>
                      </div>`
          break;
        case 'house':
          domInner = `<div id="house" style="cursor: pointer;">
                        <div id="icon" style="width: 24px; height: 24px; margin: auto;">
                          <img src="//panoappstage-1251448083.costj.myqcloud.com/ic_marke-house.svg" style="display: inline-block; width: 24.96px; height: 24px;">
                        </div>
                        <div id="name" class="text-shadow" style="height: 16px; color: rgb(255, 255, 255); font-size: 12px; line-height: 16px; font-weight: normal; letter-spacing: 0px; word-break: normal; min-width: 25px">
                          ${marker.name}
                        </div>
                      </div>`
          break
        case 'marker-black':
          domInner = `<div id="marker-black" style="width: 26px; cursor: pointer; background: rgba(0, 0, 0, 0.565); border-radius: 12px; overflow: hidden;">
                        <div id="name" class="text-shadow" style="display: -webkit-box; white-space: normal; color: rgb(255, 255, 255); font-size: 13px; line-height: 17px; width: 13px; top: 0px; justify-content: center; -webkit-box-pack: center; text-align: center;margin: 0 auto;    table-layout: fixed; word-break: break-all; text-align: center;">
                          ${marker.name}
                        </div>
                        <div id="icon" style="width: 20px; height: 20px; margin: 3px auto">
                          <img src="//panoappstage-1251448083.costj.myqcloud.com/ic_i-normal-cir.png" style="display: inline-block; width: 20px; height: 20px;">
                        </div>
                      </div>`
          break
        case 'marker-red':
          domInner = `<div>
                        <div style="18px; height: 12.96px; margin: auto">
                          <img src="//panoappstage-1251448083.costj.myqcloud.com/ic_i-tri.png" style="width: 18px; height: 12.96px; ">
                        </div>
                        <div style = "background: rgba(255, 255, 255, 0.565); border-radius: 12px; overflow:hidden" >
                          <div id="name" class="text-shadow" style="width: 16px; margin: 3px auto; color: rgb(0, 0, 0); font-size: 14px; text-align: center;">
                            ${marker.name}
                          </div>
                          <div style=" margin: auto; width: 18px; height: 18px;">
                            <img src="//panoappstage-1251448083.costj.myqcloud.com/ic_i-impo-cir.png" style="width: 18px; height: 18px;">
                          </div>
                        </div>
                      </div >`

          break
        case 'custom':
          domInner = `<div style="cursor: pointer; height: 40px;">
                        <div id="icon" class="" style="width: 24px; height: 24px; margin: auto; margin-top: 3px">
                          <img src="${marker.url}" style="display: inline-block; width: 24.96px; height: 24px;">
                        </div>
                        <div id="name" class="text-shadow" style="height: 16px; color: rgb(255, 255, 255); font-size: 12px; line-height: 16px; font-weight: normal; letter-spacing: 0px; word-break: normal">
                          ${marker.name}
                        </div>
                      </div>`
          break
        case "normal":
        default:
          domInner = `<div style="cursor: pointer; height: 40px;">
                        <div id="icon" class="big-round" style="width: 24px; height: 24px; margin: auto; margin-top: 3px"></div>
                        <div id="name" class="text-shadow" style="height: 16px; color: rgb(255, 255, 255); font-size: 12px; line-height: 16px; font-weight: normal; letter-spacing: 0px; word-break: normal">
                          ${marker.name}
                        </div>
                      </div>`
          break;
      }
      // temp 特殊处理 凤凰雪晴集人文庭院酒店项目 appid 2005285945
      if (marker.id === '1590050833087765' || marker.id === '1590571275324825') {
        domInner = `<div style="cursor: pointer; height: 50px;">
                        <div id="icon" class="" style="width: 50px; height: 50px; margin: auto; margin-top: 3px">
                          <img src="${marker.url}" style="display: inline-block; width: 50px; height: 50px;">
                        </div>
                      </div>`
      }
      dom.innerHTML = domInner
      dom.heading = marker.heading;
      dom.pitch = marker.pitch;
      dom.anchorX = 0.5;
      dom.anchorY = 0.5;
      return dom
    },
    //通用marker
    generalMarker: function (marker) {
      var src = "";
      switch (marker.type) {
        case 'info':
          src = '//panoappstage-1251448083.costj.myqcloud.com/ic_photo.png'
          break
        case 'audio':
          src = '//panoappstage-1251448083.costj.myqcloud.com/ic_mic.png'
          break
        case 'video':
          src = '//panoappstage-1251448083.costj.myqcloud.com/ic_video.png'
          break
        case 'panoVideo':
          src = '//panoappstage-1251448083.costj.myqcloud.com/ic_video.png'
          break
        case 'threeDModel':
          src = '//panoappstage-1251448083.costj.myqcloud.com/ic_model.png'
          break
        case 'syntheSize':
          src = '//panoappstage-1251448083.costj.myqcloud.com/ic_zonghe.svg'
          break
        case 'activity':
          src = '//panoappstage-1251448083.costj.myqcloud.com/ic_star.png'
          break
      }
      // var part = new window.com.vizengine.view.View();

      let dom = document.createElement("div"); // 可以为任意dom元素
      dom.style.overflow = "auto";
      // dom.style.height = "20px";
      // dom.innerHTML = (domInner.join(''));
      // console.log(pano.heading, pano.pitch);
      // dom.heading = pano.heading;
      // dom.pitch = pano.pitch;
      // dom.anchorX = 0.5;
      // dom.anchorY = 0.4;
      let domInner = ''
      switch (marker.templeteType) {
        case 'expopc':
        case 'expo':
          domInner = `<div style="cursor: pointer;">
                        <div id="icon" class="expoInfoMarker" style="width: 50px;height: 50px;"></div>
                      </div>`
          break;
        default:
          domInner = `<div style="height: 20px; display: flex; align-items: center; overflow: hidden; background: rgba(0, 0, 0, 0.4); left: 0px; top: 0px; height: 24px; clip-path: inset(0px round 12px); transform-origin: 0px 0px;">
            <div id=${marker.type === 'audio' ? 'marker-sound' : 'marker'} style="margin-left: 6px; width: 20px; height: 20px; transform-origin: 0px 0px; visibility: visible;">
              <img src=${src} style="display: inline-block; width: 20px; height: 20px;">
            </div>
            <div style=" height: 20px; transform-origin: 0px 0px; margin-right: 6px; display: flex; align-items: center;">
              <div style="display: -webkit-box; visibility: visible;color: rgb(255, 255, 255); font-size: 14px; font-weight: normal; letter-spacing: 0px; word-break: normal; top: 0px;">
                ${marker.name}
              </div>
            </div>
          </div>`
          if (marker.type === 'syntheSize') {
            dom.innerHTML = `<div></div>`
          }
          break;
      }
      dom.innerHTML = domInner
      dom.heading = marker.heading;
      dom.pitch = marker.pitch;
      dom.anchorX = 0.5;
      dom.anchorY = 0.5;
      return dom;
    }
  }



// WEBPACK FOOTER //
// ./src/assets/js/newMarkerFactory.js